import React from 'react';
import img from '../../Images/404.png'

const NotFound = () => {
    return (
        <div className='text-center mt-5'>
            <img src={img} className='img-fluid w-70' alt="" />
        </div>
    );
};

export default NotFound;